// src/components/Sidebar.jsx
import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { canAccessAdmin } from '../auth/permissions';
import './Sidebar.css';

function Sidebar() {
  const { user } = useContext(AuthContext);
  const isSystemAdmin = canAccessAdmin(user);
  const companyBasePath = user?.companyID ? `/company/${user.companyID}` : '/';
  return (
    <aside className="sidebar">
      <h1 className="sidebar-logo">DELTA MACHINERY</h1>
      <nav className="sidebar-nav">
        {!isSystemAdmin && (
          <>
            <NavLink to={companyBasePath} end className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
              설비 현황
            </NavLink>
            <NavLink to={`${companyBasePath}/order`} className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
              작업 지시
            </NavLink>
            <NavLink to={`${companyBasePath}/log`} className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
              작업 기록
            </NavLink>
          </>
        )}
        {isSystemAdmin && (
          <NavLink to="/admin" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
            관리자
          </NavLink>
        )}
      </nav>
    </aside>
  );
}

export default Sidebar;
